import { Card, Col, Row, Typography } from "antd";
import { features } from "../landingData";

const { Title, Paragraph } = Typography;

export function FeaturesSection() {
  return (
    <section className="landing-section">
      <Title level={2}>Everything You Need. Nothing You Don't.</Title>
      <Paragraph className="landing-section-subtitle">
        Built specifically for salons and barbershops.
      </Paragraph>

      <Row gutter={[24, 24]}>
        {features.map((feature) => {
          const Icon = feature.icon;

          return (
            <Col xs={24} sm={12} lg={8} key={feature.title}>
              <Card className="landing-feature-card">
                <Icon size={28} />
                <Title level={4}>{feature.title}</Title>
                <Paragraph>{feature.description}</Paragraph>
              </Card>
            </Col>
          );
        })}
      </Row>
    </section>
  );
}